 import axios from 'axios'

const state = () => ({
  tadbirlar: []
})

const getters = {
  tadbirlar(state) {
    return state.tadbirlar
  }
}

const mutations = {
  SET_TADBIRLAR(state, payload){
    state.tadbirlar = payload
  },
  DELETE_TADBIRLAR(state, id){
    state.tadbirlar.results = state.tadbirlar.results.filter((x) => x.id != id);
  },
  ADD_TADBIRLAR(state, data){
    state.tadbirlar.results.push(data);
  },
  EDIT_TADBIRLAR(state, payload){
    state.tadbirlar.results = state.tadbirlar.results.map((vm)=>{
      if(vm.id == payload.id){return payload}
      else{ return vm }
    })
  }
}

const actions = {
  getTadbirlar({commit}){
    axios.get('https://api.geomalaka.uz/api/main/kutilayotgan_tadbirlar/')
    .then((res)=>{
      commit("SET_TADBIRLAR", res.data)
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  deleteTadbirlar({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/main/kutilayotgan_tadbirlar/${id}/`)
    .then((res)=>{
      commit("DELETE_TADBIRLAR", id)
      this._vm.$toast('Deleted', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  addTadbirlar({commit}, payload){
    axios.post('https://api.geomalaka.uz/api/main/kutilayotgan_tadbirlar/', payload)
    .then((res)=>{
      commit("ADD_TADBIRLAR", res.data)
      this._vm.$toast(res.statusText, {type: 'success'});
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  editTadbirlar({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/main/kutilayotgan_tadbirlar/${payload.id}/`, payload.data)
      .then((res)=>{
        commit("EDIT_TADBIRLAR", res.data)
        this._vm.$toast('Successful', {type: 'success'});
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
